export default "__VITE_ASSET__J7mjxjuN__"